import React, { createContext, useContext, useState } from "react";

export interface ContextMenuContextValue {
  isOpen: boolean;
  position: { x: number; y: number } | null;
  open: (x: number, y: number) => void;
  close: () => void;
}

const ContextMenuContext = createContext<ContextMenuContextValue | null>(null);

export function useContextMenuContext(): ContextMenuContextValue {
  const ctx = useContext(ContextMenuContext);
  if (!ctx) throw new Error("useContextMenuContext must be used inside <ContextMenu>");
  return ctx;
}

interface ContextMenuProps {
  children: React.ReactNode;
}

export const ContextMenu: React.FC<ContextMenuProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState<{ x: number; y: number } | null>(null);

  const open = (x: number, y: number) => {
    setPosition({ x, y });
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
    setPosition(null);
  };

  const value: ContextMenuContextValue = { isOpen, position, open, close };

  return <ContextMenuContext.Provider value={value}>{children}</ContextMenuContext.Provider>;
};
